<script>
import Page from '@/components/elements/Page';
import PageIntro from '@/components/elements/PageIntro';
import TestCW from './TestCW';
import CcButton from '@/components/elements/CcButton';
import overviewMixin from '@/components/views/3-collect/_shared/overview-mixin'

export default {
    name: 'TestOverviewCW',
    components: { Page, PageIntro, TestCW, CcButton },
    mixins: [overviewMixin],
    data() {
        return {
            holder: null,
            token: null,
            tests1: null,
            filter: 'test',
            pages: {
                print: 'PrintTestCW',
                noResultFromSigner: 'TestsIncompleteCW'
            },
            testCode: null
        }
    },
    mounted() {
        this.holder = this.$store.state.pHolder;
        this.token = this.$store.state.pToken;
        this.tests1 = this.$store.state.pTests.t;
    },
    methods: {
        gotoPrintCW() {
            this.$router.push({ name: 'PrintTestCW' })
        },
        back() {
            this.$router.push({ name: 'ChoiceProofCW' })
        }
    }
}
</script>

<template>
    <Page
        class="TestOverview" @back="back">
        <div class="section">
            <PageIntro
                :head="$t('views.TestOverview.pageHeader')"
                :intro="$t('views.TestOverview.pageIntro')"/>
            <div class="section-block">
                <div class="proof-events">
                <TestCW  v-bind:holder1="holder" v-bind:test1="test1" v-for="test1 in tests1" :key="test1.ds"/>
                </div>
                <div class="section-block__footer">
                    <CcButton
                        @select="gotoPrintCW()"
                        :label="$t('views.TestOverview.createTestProofButton')"/>
                </div>
            </div>
        </div>
    </Page>
</template>
